module.exports = __webpack_public_path__ + "static/media/DELTA_logo1.d42a722d.jpg";